import type {Acc, RangesListDto} from '../typedef';

type Params = {
    acc: Acc,
    idsList: Array<string>,
};

export const prepareData = ({acc, idsList}: Params): RangesListDto => {
    return idsList.map(id => acc[id]);
};
